// extracted by mini-css-extract-plugin
export default {"idField":"hDHyDhSSenAizf5gLZMd","deleteButton":"yHHnUTIM7VcpmI3zCbZb","icon":"qwVARuMIbUGxMUWzb9M6","actionButton":"Gpvo91nXm7QQHvGP6BQh"};